import { Product } from '@df/catalog/product/product';
import { SearchResult } from '@df/search/search-result';
import { LocalProduct } from '../catalog/model/product/product.decorator';
export class LocalSearchResult extends SearchResult {
    protected override applyProductFilter(models: Product[]): Product[] {
        models = models.filter(i => !(i as LocalProduct).isSoldOut);
        return super.applyProductFilter(models);
    }
}
